export default {
    statuses: state => {
        return state.statuses;
    },

    yesNoStatus: state =>{
        return state.yesNoStatus
    },

    yesNoStatusEn: state =>{
        return state.yesNoStatusEn
    },

    presentAbsentStatus: state =>{
        return state.presentAbsentStatus
    },

    cycles: state =>{
        return state.cycles
    },

    radiologyTypes: state =>{
        return state.radiologyTypes
    },

    gravidityTypes: state =>{
        return state.gravidityTypes
    },

    ipTypes: state =>{
        return state.ipTypes
    },

    posNegStatus: state =>{
        return state.posNegStatus
    },


    physicalExamTypes: state =>{
        return state.physicalExamTypes
    },

    papSmear: state =>{
        return state.papSmear
    },
    paymentTypes: state =>{
        return state.paymentTypes
    },
    paymentTypesForReturn:state =>{
        return state.paymentTypesForReturn
    },
    excessPaymentTypes: state =>{
        return state.excessPaymentTypes
    },

}
